module.exports = __webpack_public_path__ + "static/media/bullseye.fa4d16b4.svg";